import React from 'react';
import { updateClub, updateResponse, getAllowedClubs, getClub } from "../../api/clubapi";
import {
    Form,
    Label, Input,
    Button, Col, Row,
} from 'reactstrap';
import { Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import CustomDatePicker from '../CustomDatePicker';
import PopupError from '../PopupError';
import CardTitle from '../CardTitle';
import FormValidator from '../FormValidation';
import { formatEditDate, formatDateFields, formatInTimeZoneDate, formatInTimeZoneDateTime } from '../../helpers';
import cloneDeep from 'lodash/cloneDeep';
import '../css/EditCreate.css';
import RequiredFieldNotation from '../utils/RequiredFieldNotation';
import feedback from '../utils/feedback';
import InputFeedback from '../utils/InputFeedback';

class ClubEdit extends React.Component {

    constructor(props) {
        super(props);
        if (this.props.route.location.state) {
            if (this.props.route.location.state.from === 'branches') {
                this.props.route.history.push('/secure/branches');
                this.props.route.history.push(this.props.route.match.url);
            }
            if (this.props.route.location.state.from === 'view') {
                this.props.route.history.push('/secure/clubs');
                this.props.route.history.push(this.props.route.match.url);
            }
        }

        this.validator = new FormValidator([
            {
                field: 'name',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'clubCode',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'clubCode',
                method: 'isNumeric',
                validWhen: true,
                message: 'Club code must be a number.'
            },
            {
                field: 'startDate',
                method: this.isBefore,
                validWhen: true,
                message: 'Start date must be before end date.'
            },
            {
                field: 'customerServiceEmail',
                method: (fieldValue) => {
                    if (fieldValue.trim() === '') {
                        return false
                    }

                    return this.isEmail(fieldValue);
                },
                validWhen: false,
                message: 'Please enter valid emails.'
            }
        ]);

        let club = null;
        if (this.props.route.location.club)
            if (this.props.route.location.state.club)
                club = this.props.route.location.state.club;

        this.state = {
            readOnly: true,
            club: club,
            cancel: false,
            saved: false,
            error: false,
            errorMessage: [],
            edit: false,
            validation: this.validator.valid(),
            baseState: '',
            parentClubs: [],
            clubId: this.props.route.match.params.id
        };

        this.closeModal = this.closeModal.bind(this);
    }
    isBefore = (confirmation, state) => (state.endDate >= confirmation || !state.endDate);
    isAfter = (confirmation, state) => (state.startDate <= confirmation);
    isEmail = (state) => {
        return (!state.match(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25}(;[ ]{0,1}([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})*$/));
    }

    //Removes the readonly attribute on edit and hides edit button / save and cancel buttons appear
    handleEdit() {
        this.setState(state => ({
            readOnly: !state.readOnly,
            edit: true
        }));
    }

    getDataClub(data, _this) {
        var x = JSON.stringify(cloneDeep(data.data.data))
        _this.setState({
            club: data.data.data,
            baseState: x,
            _startDate: !data.data.data.startDate ? '' : formatInTimeZoneDate(data.data.data.startDate, ''),
            _endDate: !data.data.data.endDate ? '' : formatInTimeZoneDate(data.data.data.endDate, '')
        })
    }

    //Resets view to previous state, goes back to view club
    handleCancel = () => {
        if (this.state.edit) {
            this.setState(state => ({
                readOnly: true,
                club: JSON.parse(state.baseState),
                edit: false,
                //sets validation to previous state
                validation: this.validator.valid()
            }))

            document.getElementById("startDate").value = !this.state.club.startDate ? "" : this.state.club.startDate.substring(0, 10);
            document.getElementById("endDate").value = !this.state.club.endDate ? "" : this.state.club.endDate.substring(0, 10);

            this.submitted = false;
            //Removes the is-invalid class from all inputs when editing is canceled
            var els = document.getElementsByClassName('is-invalid')
            while (els[0]) {
                els[0].classList.remove('is-invalid')
            }

        } else {
            this.setState({
                cancel: true
            })
        }
    }

    //Shows options of array and the saved routerType is selected by default.
    renderRouters(routerType) {
        let arr = ["", "FTP", "Service BUS", "Bulk FTP"];
        var Data = arr,
            MakeItem = function (X) {
                if (X === routerType) {
                    var selected = true;
                }
                return <option className="form-control-plaintext border-bottom" key={X} defaultValue={selected}>{X}</option>;
            };
        return Data.map(MakeItem);
    }

    componentDidMount() {
        this.props.getAllowedClubs(function (result, _this) { _this.getData(result, _this) }, this, this.state.clubId)

        if (this.state.club == null) {
            const clubId = this.props.route.match.params.id;
            this.props.getClub(function (result, _this) { _this.getDataClub(result, _this) }, this, clubId)
        } else if (this.props.route.location.state.club) {
            var x = JSON.stringify(cloneDeep(this.props.route.location.state.club));
            this.setState({
                baseState: x,
            });
            this.state._startDate = !this.state.club.startDate ? '' : formatInTimeZoneDate(this.state.club.startDate, '');
            this.state._endDate = !this.state.club.endDate ? '' : formatInTimeZoneDate(this.state.club.endDate, '');
        }
    }

    renderParentClubNames() {
        let parentClubs = this.state.parentClubs;
        console.log(this.state.club);
        return parentClubs.map((parentClub, index) => {
            if (this.state.club.parentClubName === parentClub.name) {
                var selected = true;
            }
            return (
                <option id={parentClub.clubId} key={index} defaultValue={selected}>{parentClub.name}</option>
            );
        });
    }

    //Shows "Edit club" if user is editting and "View club" if no button was toggled
    renderCardTitle() {
        if (!this.state.readOnly) {
            return <div className="card-header text-center"> Edit Club</div>
        } else {
            return <div className="card-header text-center"> View Club</div>
        }
    }

    closeModal() {
        this.setState({ error: false });
        this.submitted = false;
    }

    componentDidUpdate(prevProps) {
        //Checks if there is a response on update
        if (this.props.updateResult !== prevProps.updateResult) {
            console.log("a response exists");
            var result = this.props.updateResult
            console.log(result, "this is the result");
            //Checks if the response is success or has errors.
            if (result) {
                if (result.data.success) {
                    var x = JSON.stringify(cloneDeep(this.state.club));
                    this.setState(state => ({
                        baseState: x,
                        saved: true,
                        edit: false,
                        readOnly: !state.readOnly,
                        validation: this.validator.valid(),
                        _startDate: !state.club.startDate ? '' : formatDateFields(state.club.startDate + "T00:00:00", ''),
                        _endDate: !state.club.endDate ? '' : formatDateFields(state.club.endDate + "T00:00:00", '')
                    }));

                    //When saving is success, it brings the saved results again for updating footer.
                    this.props.getClub(function (result, _this) { _this.getDataClub(result, _this) }, this, this.state.club.clubId)

                } else if (result.data.success == false) {
                    var errorList = [];
                    result.data.errors.map(function (e) { errorList.push(e.message) })
                    this.setState({ error: true, errorMessage: errorList })
                } else {
                    let message = Object.keys(result.data.errors).map((function (e) { return 'there was an error saving ' + e }));
                    this.setState({ error: true, errorMessage: message });
                }
                this.props.updateResponse("");
            }
        }
    }

    getData(data, _this) {
        //Unshift adds an empty value to the start of the array, for creating an empty <option> tag
        let parentClubs = data.data.data;
        parentClubs.unshift("");

        _this.setState({
            parentClubs: parentClubs,
            loading: false,
        })
    }

    //Calls API for updating club on form submit
    handleSubmit = event => {
        event.preventDefault();

        var updVal = this.state.club;
        updVal.startDate = document.getElementById("startDate").value;
        updVal.endDate = document.getElementById("endDate").value;
        this.setState({ club: updVal }, () => {
            const validation = this.validator.validate(this.state.club);
            this.setState({ validation });
            if (validation.isValid) {
                // handle actual form submission here
                this.props.updateClub(updVal);
            }
        });
    }

    isInvalid(e) {
        var input = e.target;
        if (input.value) { input.classList.remove("is-invalid"); }
        else { input.classList.add("is-invalid"); }
    }

    routerType(type) {
        switch (type) {
            case "ServiceBus":
                return "Service BUS";
            case "BulkFtp":
                return "Bulk FTP";
            default:
                return type;
        }
    }

    render() {
        const club = this.state.club

        if (this.state.cancel) {
            return <Redirect
                to={{
                    pathname: `/secure/clubs`,
                }}
            />;
        }

        let validation = this.submitted ?
            this.validator.validate(this.state.club) :
            this.state.validation;

        return (
            <div className="card">

                <CardTitle
                    component={"Club"}
                    readOnly={this.state.readOnly} />

                <PopupError
                    open={this.state.error}
                    onClose={this.closeModal}
                    onClick={this.closeModal}
                    errorMessage={this.state.errorMessage}
                />

                <div className="card-body fs-12">
                    {club && <Form onSubmit={this.handleSubmit}>
                        <RequiredFieldNotation />
                        <div className="row">
                            <div className="col-md-6">
                                <Col className={`${validation.name.isInvalid && this.submitted ? 'has-error' : ''}`}>
                                    <Label htmlFor='clubName' className="required-hint mt-4"><strong>Club</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        id="clubName"
                                        type="text"
                                        name="name"
                                        maxLength="150"
                                        autoComplete="off"
                                        // required
                                        className={this.state.readOnly ? '' : 'input-editable'}
                                        value={club.name}
                                        onChange={(e) => { this.isInvalid(e); var x = club; x.name = e.target.value; this.setState({ club: x }) }} />
                                    <span className="help-block">{validation.name.message}</span>
                                </Col>
                                <Col className={`${validation.clubCode.isInvalid && this.submitted ? 'has-error' : ''}`}>
                                    <Label htmlFor='clubCode' className="required-hint mt-4"><strong>Club code</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        type="number"
                                        name="clubCode"
                                        id='clubCode'
                                        // required
                                        className={this.state.readOnly ? '' : 'input-editable'}
                                        value={club.clubCode}
                                        onChange={(e) => { this.isInvalid(e); var x = club; x.clubCode = e.target.value; this.setState({ club: x }) }} />
                                    {!this.state.readOnly && <InputFeedback feedbackText={feedback.clubCode} id='clubCode' />}
                                    <span className="help-block">{validation.clubCode.message}</span>
                                </Col>
                                <Col>
                                    <Label htmlFor='parentClubName' className="mt-4" ><strong>Parent club</strong></Label>
                                    <label className={this.state.readOnly ? 'select-disabled' : 'select'}>
                                        <select
                                            id="parentClubName"
                                            name="parentClubName"
                                            className={this.state.readOnly ? 'form-control' : 'form-control input-editable'}
                                            disabled={this.state.readOnly} value={club.parentClubName ? club.parentClubName : ''}
                                            onChange={(e) => {
                                                var x = this.state.club; x.parentClubName = e.target.value;
                                                var y = this.state.club; y.parentClubId = e.target[e.target.selectedIndex].getAttribute('id');
                                                this.setState({ club: x, club: y })
                                            }}
                                        >
                                            {this.renderParentClubNames()}
                                        </select>
                                    </label>
                                </Col>

                                {!this.state.readOnly && <Row>
                                    <div className="col-md-6">
                                        <Col className={`${validation.startDate.isInvalid && this.submitted ? 'has-error' : ''}`}>
                                            <Label htmlFor='startDate' className="mt-4"><strong>Start date</strong></Label>
                                            <CustomDatePicker
                                                id="startDate"
                                                readOnly={this.state.readOnly}
                                                defValue={!club.startDate ? "" : formatInTimeZoneDate(club.startDate).substring(0, 10)}
                                                label="Start Date"
                                            />
                                            <InputFeedback feedbackText={feedback.startDate} id='startDate' />
                                            <span className="help-block-calendar">{validation.startDate.message}</span>
                                        </Col>
                                    </div>
                                    <div className="col-md-6">
                                        <Col>
                                            <Label htmlFor='endDate' className="mt-4"><strong>End date</strong></Label>
                                            <CustomDatePicker
                                                id="endDate"
                                                readOnly={this.state.readOnly}
                                                defValue={!club.endDate ? "" : formatInTimeZoneDate(club.endDate).substring(0, 10)}
                                                label="End Date"
                                            />
                                        </Col>
                                    </div>
                                </Row>}
                                {this.state.readOnly && <div className="col-md-12">
                                    <Row>
                                        <div className={this.state.readOnly ? 'col-md-6 _startDate ' : "col-md-6 hide"}>
                                            <Label htmlFor='_startDate' className="mt-4"><strong>Start date</strong></Label>
                                            <Input
                                                id="_startDate"
                                                readOnly={true}
                                                className=''
                                                value={this.state._startDate}>
                                            </Input>

                                        </div>
                                        <div className={this.state.readOnly ? 'col-md-6 _endDate' : "col-md-6 hide"}>
                                            <Label htmlFor='_endDate' className="mt-4"><strong>End date</strong></Label>
                                            <Input
                                                id="_endDate"
                                                readOnly={true}
                                                className=''
                                                value={this.state._endDate}>
                                            </Input>
                                        </div>
                                    </Row>
                                </div>}
                                <Col>
                                    <Label htmlFor='stripeMerchantId' className="mt-4"><strong>Stripe MerchantId</strong></Label>
                                    <Input readOnly={true}
                                        id="stripeMerchantId"
                                        type="text"
                                        name="stripeMerchantId"
                                        className={''}
                                        value={club.stripeMerchantId}
                                    />
                                    {/* <span className="help-block">{validation.clubCode.message}</span> */}
                                </Col>
                                <Col>
                                </Col>
                            </div>
                            <div className="col-md-6">
                                <Col>
                                    <Label htmlFor='routerType' className="mt-4"><strong>Transfer method</strong></Label>
                                    <label className={this.state.readOnly ? 'select-disabled' : 'select'}>
                                        <select
                                            id="routerType"
                                            name="routerType"
                                            className={this.state.readOnly ? 'form-control' : 'input-editable form-control'}
                                            disabled={this.state.readOnly} value={this.routerType(club.routerType)}
                                            onChange={(e) => { var x = this.state.club; x.routerType = e.target.value; this.setState({ club: x }) }}
                                        >
                                            {this.renderRouters(club.routerType)}
                                        </select>
                                    </label>
                                </Col>

                                <Col>
                                    <Label htmlFor='routerConnection' className="mt-4"><strong>Router connection</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        type="textarea"
                                        name="routerConnection"
                                        id='routerConnection'
                                        maxLength="500"
                                        className={this.state.readOnly ? 'txt-input-size' : 'input-editable txt-input-size'}
                                        onChange={(e) => { var x = club; x.routerConnection = e.target.value; this.setState({ club: x }) }}
                                        value={club.routerConnection} />
                                    {!this.state.readOnly && <InputFeedback feedbackText={feedback.routerConnection} id='routerConnection' />}
                                </Col>

                                <Col >
                                    <Label htmlFor='routerCredentials' className="mt-4"><strong>Router credentials</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        type="input"
                                        className={this.state.readOnly ? '' : 'input-editable'}
                                        name="routerCredentials"
                                        id='routerCredentials'
                                        maxLength="500"
                                        onChange={(e) => { var x = club; x.routerCredentials = e.target.value; this.setState({ club: x }) }}
                                        value={club.routerCredentials} />
                                    {!this.state.readOnly && <InputFeedback feedbackText={feedback.routerCredentials} id='routerCredentials' />}
                                </Col>
                                <Row>
                                    <div className="col-md-6">
                                        <Col>
                                            <Label htmlFor='ftpHost' className="mt-4"><strong>FTP host</strong></Label>
                                            <Input readOnly={this.state.readOnly}
                                                type="input"
                                                name="ftpHost"
                                                id='ftpHost'
                                                maxLength="500"
                                                className={this.state.readOnly ? '' : 'input-editable'}
                                                onChange={(e) => { var x = club; x.ftpHost = e.target.value; this.setState({ club: x }) }}
                                                value={club.ftpHost} />
                                            {!this.state.readOnly && <InputFeedback feedbackText={feedback.ftpHost} id='ftpHost' />}
                                        </Col>
                                    </div>
                                    <div className="col-md-6">
                                        <Col>
                                            <Label htmlFor='ftpPort' className="mt-4"><strong>FTP port</strong></Label>
                                            <Input readOnly={this.state.readOnly}
                                                type="number"
                                                name="ftpPort"
                                                id='ftpPort'
                                                className={this.state.readOnly ? '' : 'input-editable'}
                                                value={club.ftpPort ? club.ftpPort : ''}
                                                onChange={(e) => { var x = club; x.ftpPort = e.target.value; this.setState({ club: x }) }}
                                            />
                                            {!this.state.readOnly && <InputFeedback feedbackText={feedback.ftpPort} id='ftpPort' />}
                                        </Col>
                                    </div>
                                </Row>
                                <Row>
                                    <div className={`${validation.customerServiceEmail.isInvalid ? 'col-md-12 has-error' : 'col-md-12'}`}>
                                        <Col>
                                            <Label htmlFor='email' className="mt-4"><strong>Customer Service Email</strong></Label>
                                            <Input
                                                readOnly={this.state.readOnly}
                                                type="text"
                                                maxLength="256"
                                                name="customerServiceEmail"
                                                autoComplete="off"
                                                id='email'
                                                className={this.state.readOnly ? '' : 'input-editable form-control'}
                                                value={club.customerServiceEmail}
                                                onChange={(e) => { this.isInvalid(e); var x = club; x.customerServiceEmail = e.target.value; this.setState({ club: x }) }} />
                                            {!this.state.readOnly && <InputFeedback feedbackText={feedback.email} id='email' />}
                                            <span className="help-block">{validation.customerServiceEmail.message}</span>
                                        </Col>
                                    </div>
                                </Row>
                                <div className="text-right float-bottom">
                                    <Button onClick={this.handleCancel.bind(this)} className="cancel-btn">CANCEL</Button>
                                    <Button onClick={this.handleEdit.bind(this)} className={this.state.readOnly ? 'edit-btn' : 'd-none'}>EDIT</Button>
                                    <Button onClick={this.handleSubmit.bind(this)} type="submit" color="primary" className={this.state.readOnly ? 'd-none' : 'save-btn'}>SAVE</Button>
                                </div>
                            </div>
                        </div>
                    </Form>
                    }
                    <Col>
                        <hr />
                    </Col>
                    {club && <Col>
                        <Row>
                            <div className="col-md-1">
                                <div className="inline-label"><strong>ID</strong></div>
                                <p className="editFooterText">{club.clubId}</p>
                            </div>
                            <div className="col-md-3">
                                <div className="inline-label"><strong>Created by</strong></div>
                                <p className="editFooterText">{club.createdBy}</p>
                            </div>
                            <div className="col-md-3">
                                <div className="inline-label"><strong>Created date</strong></div>
                                <p className="editFooterText">{formatInTimeZoneDateTime(club.createdDate, '')}</p>
                            </div>
                            <div className="col-md-2">
                                <div className="inline-label"><strong>Updated by</strong></div>
                                <p className="editFooterText">{club.updatedBy}</p>

                            </div>
                            <div className="col-md-3">
                                <div className="inline-label"><strong>Updated date</strong></div>
                                <p className="editFooterText">{formatInTimeZoneDateTime(club.updatedDate, '')}</p>
                            </div>
                        </Row>
                    </Col>
                    }
                </div>
            </div>
        );
    }
}
export default connect(
    state => {
        return {
            club: state.data.club,
            updateResult: state.data.updateResult,
            parentClubs: state.data.parentClubs
        }
    },
    dispatch => ({
        updateClub: (callback, conext) => { dispatch(updateClub(callback, conext)) },
        updateResponse: (response) => { dispatch(updateResponse(response)) },
        getAllowedClubs: (callback, context, id) => { dispatch(getAllowedClubs(callback, context, id)) },
        getClub: (callback, context, id) => { dispatch(getClub(callback, context, id)) },
    }
    )
)(ClubEdit);

